const isEmpty = require ('underscore').isEmpty
const {h, render, Component} = require('preact');
const SupportAPIHelper = require('../../../support/frontend/helpers/API')
const FlexibleMain = require('../views/flexible_main')
const EmailFormMainContainer = require('../../../web_2018/frontend/components/containers/email_form/email_form')

class FlexibleFormEMEA extends Component {
  constructor(props) {
    super(props);
  }

  getApiTimeout() {
    return  Groupon.Utils.getConfigFromDom().flexibleApiTimeout
  }

  fetchHelpContent(tagLinesBase, defaultTagLine) {
    let get_flexible_content_api_timeout_in_milliseconds = this.getApiTimeout() || 60000
    let data = this.getRequestParams(tagLinesBase, defaultTagLine, this.props.contactChannelParams.selectedItem)
    let urls = this.getHelpContentPaths()
    let cb = (results) => {
      this.helpContentCb(results)
    }
    SupportAPIHelper.parallel(urls, data, cb, false, null, get_flexible_content_api_timeout_in_milliseconds)
  }

  getRequestParams(tagLinesBase, defaultTagLine, currentOrder) {
    let requestParams = []
    let tagLines = {
      baseTagline: tagLinesBase,
      defaultTagLine: defaultTagLine
    }
    if(this.arePriorityTaglinesPresent(currentOrder)) {
      let priorityTaglines = currentOrder.metadata.priorityTaglines
      tagLines["priorityTaglines"] = priorityTaglines
    }
    let stepThreeParams = {tagLineData: tagLines, type: "flexible_step_three"}
    requestParams.push(stepThreeParams)
    return requestParams
  }

  arePriorityTaglinesPresent(currentOrder) {
    return currentOrder && currentOrder.metadata.priorityTaglines && currentOrder.metadata.priorityTaglines.length > 0
  }


  getHelpContentPaths() {
    let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/get_flexible_content?should_display_cms_content=false`
    return [url]
  }

  helpContentCb(results) {
    if(results)
      this.helpContentSuccess(results)
    else
      this.helpContentError()
  }

  helpContentSuccess(results) {
    let content = this.resolveResponse(results[0])
    let contentForFlexibleMain = []
    contentForFlexibleMain.push(content)
    if (contentForFlexibleMain)
      this.setState({'flexibleObjects': contentForFlexibleMain, 'responseReceived' : true})
  }

  resolveResponse(contents) {
    if(this.isResponseTaglinePresent(contents)) {
      var responseKey = contents['responseTagline']
      this.setEscalateToMerchantFlag(responseKey)
      return contents[responseKey]
    }
    return {}
  }

  isResponseTaglinePresent(contents) {
    if(contents) {
      return contents['responseTagline']
    }
    return null
  }

  getCategoryId() {
    return this.props.contactChannelParams.dropdownCategory
  }

  getSubCategoryId() {
    return this.props.contactChannelParams.dropdownSubcategory
  }

  setEscalateToMerchantFlag(responseKey) {
    var escalateToMerchant = this.isEscalateToMerchantPresent(responseKey)
    if (this.props.contactChannelParams && this.props.contactChannelParams.selectedItem) {
      this.props.contactChannelParams.selectedItem.escalateToMerchantFlag = escalateToMerchant
    }
  }

  isEscalateToMerchantPresent(responseTagLine) {
    if (this.props.contactChannelParams && this.props.contactChannelParams.selectedItem) {
        return this.props.contactChannelParams.selectedItem.escalateToMerchant && this.isTagPresent(responseTagLine, 'escalate_to_merchant')
    }
  }

  isTagPresent(tagLine, tag) {
    return tagLine.includes(tag)
  }

  componentDidMount() {
    let tagLinesBase = `${this.getCategoryId()},${this.getSubCategoryId()}`
    let defaultTagLine
    if (this.props.contactChannelParams.selectedItem && this.props.contactChannelParams.selectedItem.metadata) {
        defaultTagLine = `${this.props.contactChannelParams.selectedItem.metadata.tagLine}`
    }
    this.fetchHelpContent(tagLinesBase, defaultTagLine)
  }

  render() {
    var FormObject = this.state.flexibleObjects && !isEmpty(this.state.flexibleObjects[0]) ? FlexibleMain : EmailFormMainContainer
    if (this.state.responseReceived) {
      return (
        <FormObject handleCallUsLink = {this.props.handleCallUsLink} contactChannelParams={this.props.contactChannelParams} flexibleObjects={this.state.flexibleObjects}
                    handleClick={this.props.handleClick} resetState={this.props.resetState} guestOrder= {this.props.guestOrder} contactChannelConfig={this.props.contactChannelConfig}/>
      )
    }
  }
}

module.exports = FlexibleFormEMEA
